import { fetchApi } from '@/config/axiosSetting.ts';
import { AdjusterReportQueryResponseType } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterReportPage/adjusterReportQuery.type';

export const adjusterReportQueryFunction = (
  id: string,
): Promise<AdjusterReportQueryResponseType[]> =>
  fetchApi.get(`/my_files/${id}/adjuster_report/entry_tabs/`);
